export default __webpack_public_path__ + "static/media/coin3.31bc03a4.png";